import { Component, EventEmitter, Input, OnInit, Output, output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BackendService } from '../../services/backend/backend.service';
import { TeiasoftLoaderService } from '../../services/teiasoft-bucket/teiasoft-loader.service';
import { finalize } from 'rxjs/operators';
import { TeiasoftToasterService } from '../../services/teiasoft-bucket/teiasoft-toaster.service';

@Component({
  selector: 'app-modal-feasibility-options-itdcr',
  templateUrl: './modal-feasibility-options-itdcr.component.html',
  styleUrl: './modal-feasibility-options-itdcr.component.scss'
})
export class ModalFeasibilityOptionsItdcrComponent implements OnInit {

  title: string = "";
  @Input() enquiryNo: string = "";
  @Input() itemNo: string = ""
  @Input() feasibilitySource: string = "";
  @Input() feasibilitySourceDescription: string = "";
  @Input() readOnly: boolean = false;

  @Output() onCancel = new EventEmitter<void>();
  @Output() onSubmit = new EventEmitter<'Confirm' | 'Reject'>();
  showItdcrViewerModal: boolean = false;
  selectedItdcrNo: string = '';

  constructor(private translate: TranslateService, private backendService: BackendService, private loader: TeiasoftLoaderService, private toaster: TeiasoftToasterService) { }


  ngOnInit(): void {
    this.title = this.translate.instant("feasibility.itdcrTitle");
  }

  onCancelClick() {
    this.onCancel.emit();
  }

  onRejectClick() {
    this.onSubmit.emit('Reject');
  }

  onConfirmClick() {
    this.onSubmit.emit('Confirm');
  }

  get showItdcrHistoryLink(): boolean {
    const source = String(this.feasibilitySource ?? '').trim().toLowerCase();
    return source === 'itdcr' || source === 'itr';
  }

  onNavigateToItdcrHistory() {
    if (!this.enquiryNo || !this.itemNo || !this.showItdcrHistoryLink) return;

    this.loader.start();
    this.backendService.getItdcrNumberByItemAndCategory(this.enquiryNo, this.itemNo, 'F')
      .pipe(finalize(() => this.loader.stop()))
      .subscribe(res => {
        const itdcrNo = res?.itdcrNo?.trim?.() || '';
        if (!itdcrNo) {
          this.toaster.show("info", this.translate.instant("itdcr.notAvailableForItem"));
          return;
        }

        this.selectedItdcrNo = itdcrNo;
        this.showItdcrViewerModal = true;
      });
  }

  onCloseItdcrViewer() {
    this.showItdcrViewerModal = false;
    this.selectedItdcrNo = '';
  }

}
